<template>
  <div>
    <TopNav v-bind:t="true" v-bind:m="minute" v-bind:s="second" />
    <div class="main-content"> <!-- If data not ready -->
      <div v-if="loading" class="container pt-5 mt-5">
        <div v-if="message" class="col-12 mt-5 alert alert-primary text-center">{{ message }}</div>
      </div>
      <div v-else class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-if="examDetail !== null" v-bind:route="'HomeWorkDetail'" v-bind:minute="minute" v-bind:exam_status="headStatus" />
            </div>
            <router-link class="btn btn-light mr-1" :to="{ name: previousPageRoute }"><i class="fe fe-arrow-left"></i> Sınavdan Çık</router-link>
            <a v-if="examDetail !== null && examDetail.pdf_file" :href="examDetail.pdf_file" target="_blank" class="btn btn-primary"><i class="fe fe-arrow-down"></i> Soru Kitapçığını İndir</a>
          </div>
        </div>
        <div class="container-fluid pt-5">
          <div v-if="!examIsActive && !examIsAvailable" class="col-12">
            <ScoreBoard v-bind:score="quizResult" v-bind:result_permission="resultPermission" />
          </div>
          <div v-if="message" class="col-12 alert alert-primary text-center">{{ message }}</div>
          <div v-if="!examIsActive && examIsAvailable" class="mb-3">
            <button @click.prevent="startExam()"  class="btn btn-lg btn-primary btn-block">{{ startButtonText }}</button>
          </div>
          <div class="card text-center" v-if="ready">
            <div class="row">
              <!-- Left Tabs -->
              <div class="col-12 col-lg-2 border-right border-light p-0-lg">
                <ul class="nav flex-column nav-pills nav-fill p-3 pl-4">
                  <li class="nav-item" :key="index" v-for="(question, index) in regeneratedQuestions">
                    <a href="javascript:;" @click="activeLessonTab = question[0].key; activeLessonTabChanged = true; drawLessonIndex = index" class="nav-link" :class="activeLessonTabReturner(question[0].key) ? 'active' : ''">{{ question[0].ders_isim }}</a>
                  </li>
                </ul>
              </div>
              <!-- Content -->
              <div class="col-12 col-lg-10 pl-lg-0" v-show="question[0].key == activeLessonTab" :key="index" v-for="(question, index) in regeneratedQuestions">
                <div class="row">
                  <div class="col">
                  </div>
                  <div class="col-auto">
                    <div class="nav btn-group d-inline-flex">
                      <button @click="mode = 'normal'" class="btn btn-white" :class="mode == 'normal' ? 'active' : ''" :aria-selected="mode == 'normal' ? true : false" data-balloon-pos="up" aria-label="Normal Görünüm Modu">
                        <span class="fe fe-sidebar"></span>
                      </button>
                      <button @click="mode = 'optic'" class="btn btn-white" :class="mode == 'optic' ? 'active' : ''" :aria-selected="mode == 'optic' ? true : false" data-balloon-pos="up" aria-label="Optik Görünüm Modu">
                        <span class="fe fe-list"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="mode == 'normal'">
                  <div class="card-header spec-header"><!--  v-for="(q, index) in question[0].soru_bilgileri" :key="index" -->
                    <ul class="nav nav-pills card-header-pills justify-content-center spec-nav">
                      <li class="nav-item" :class="activeTabCheck(question[0].key, li.sinav_soru_id) ? 'clicked ' + tabStatusClass(question[0].key, li.sinav_soru_id) : tabStatusClass(question[0].key, li.sinav_soru_id)" :key="i" v-for="(li, i) in question[0].soru_bilgileri">
                        <a @click.prevent="active = (i+1);" class="nav-link" :class="active == (i+1) ? 'active' : ''" href="javascript:;">{{ (i + 1) }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="card-body question-card-body" :class="examIsActive || !examIsAvailable ? '' : 'blurred'">
                    <div class="question-col" :key="i" v-for="(q, i) in questions">
                      <div class="card card-fill question-card mb-0 shadow-sm m-3" v-show="(i2 + 1) == active && parseInt(i) == parseInt(activeLessonTab)" :key="i2" v-for="(detail, i2) in q[0].soru_bilgileri">
                        <div class="card-header">
                          <div class="row align-items-center">
                            <div class="col-12 col-lg-8 text-left">
                              <small>
                                Soru No: {{ (i2 + 1) }} <span class="alert alert-danger p-1 ml-3" v-if="emergencyAlert">{{ emergencyAlert }}</span>
                              </small>
                            </div>
                            <div class="col-12 col-lg-4 text-center">
                              <div class="btn-group my-2">
                                <a href="javascript:;" @click.prevent="active = (active-1)" class="btn btn-sm btn-white" data-balloon-pos="up" aria-label="Geri" :class="(i2==0 ? 'disabled' : '')">
                                  <i class="fe fe-chevron-left"></i> Geri
                                </a>
                                <a href="javascript:;" @click.prevent="active = (active+1)" class="btn btn-sm btn-white" data-balloon-pos="up" aria-label="İleri" :class="(q[0].soru_bilgileri.length==(i2+1) ? 'disabled' : '')">
                                  İleri <i class="fe fe-chevron-right"></i>
                                </a>
                                <a href="javascript:;" @click.prevent="cleanDrawArea(detail.sinav_soru_id)" class="btn btn-sm btn-white ml-3" data-balloon-pos="up" aria-label="Çizim Alanını Temizle">
                                  <i class="fe fe-edit-3"></i>
                                </a>
                                <!--
                                <a v-if="q.vimeo_id != 0 && q.vimeo_id != '' && q.vimeo_id != '0'" :class="!examIsActive ? '' : 'disabled'" class="btn btn-sm btn-white" data-balloon-pos="up" aria-label="Soru Çözüm Videosunu İzle" @click="videoToggle(q)">
                                  <i class="fe fe-play"></i>
                                </a>
                                <router-link :to="!examIsActive ? { name: 'HomeWorkPrint', params: { id: examID } } : { name : 'Home' }" :class="!examIsActive ? '' : 'disabled'" class="btn btn-sm btn-white" data-balloon-pos="up" aria-label="Sonuçları Yazdır">
                                  <i class="fe fe-printer"></i>
                                </router-link>
                                -->
                                <a data-balloon-pos="up" :aria-label="'Soru ID: ' + detail.sinav_soru_id" class="btn btn-sm btn-white">
                                  <i class="fe fe-help-circle"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a :ref="'img' + detail.sinav_soru_id" :id="'img' + detail.sinav_soru_id" class="canvas_area">
                          <canvas :ref="'canvas' + detail.sinav_soru_id">
                          </canvas>
                          <img class="card-img-top question_img img-fluid" :title="detail.soru_path ? '' : 'Soru görseli bulunamadı!'" :src="detail.soru_path ? detail.soru_path : '/assets/img/illustrations/lost.svg'" :alt="detail.sinav_soru_id + '. Soru Resmi'" />
                        </a>
                        <div class="card-body mt-0">
                          <div class="row align-items-center">
                            <!--
                            <div class="col-12 mb-3" v-if="!examIsActive && answersKeys[i][detail.sinav_soru_id] != answers[i][detail.sinav_soru_id]">
                              <h1 class="badge-answer badge-dark">Bu sorunun doğru cevabı: {{ answersKeys[i][detail.sinav_soru_id] }}</h1>
                            </div>
                            -->
                            <div class="col-12">
                              <div class="btn-group d-flex" :class="!examIsActive || sendingAnswer ? 'disabled' : ''">
                                <button 
                                  :key="answer_index" v-for="(answer_name, answer_index) in optionPack"
                                  class="btn btn-default nav-justified" :class="answerClass(answer_name, i, detail.sinav_soru_id)" :disabled="sendingAnswer ? true : false"
                                  @click.prevent.stop="!sendingAnswer ? answerSend(answer_name, i, detail.sinav_soru_id) : false;">
                                  <i :class="answers[i][detail.sinav_soru_id] == answer_name ? 'fe-stop-circle' : 'fe-circle'" class="fe"></i> {{ sendingAnswer == true && sendingAnswerName == answer_name && sendingAnswerIndex == i ? 'Cevap gönderiliyor...' : answer_name }}
                                </button>
                              </div>
                              <button v-if="answers[i][detail.sinav_soru_id] != null && answers[i][detail.sinav_soru_id] != '' && examIsActive && !sendingAnswer" @click.prevent.stop="answerSend(answers[i][detail.sinav_soru_id], i, detail.sinav_soru_id, true)" class="mt-3 btn btn-dark btn-block">Bu soruyu boş bırak</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card" v-else-if="mode == 'optic'">
                   <div class="card-body question-card-body" :class="examIsActive || ! examIsAvailable ? '' : 'blurred'">
                    <div class="col-12 col-lg-12 question-col">
                      <div class="table-responsive">
                        <table class="table table-sm table-striped">
                          <thead>
                            <tr>
                              <td scope="col">Soru No</td>
                              <td scope="col" :key="optionIndex" v-for="(answerName, optionIndex) in optionPack">{{ answerName }}</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr :question="q" :key="i" v-for="(q, i) in questions[activeLessonTab][0].soru_bilgileri">
                              <td>{{ q.soru_sira }}</td>
                              <td :key="optionIndex" v-for="(answerName, optionIndex) in optionPack">
                                <button 
                                  class="btn btn-default nav-justified" 
                                  :class="answerClass(answerName, activeLessonTab, q.sinav_soru_id)" 
                                  :disabled="!examIsActive || sendingAnswer ? true : false"
                                  @click.prevent.stop="!sendingAnswer ? answerSend(answerName, activeLessonTab, q.sinav_soru_id) : false;">
                                    <i 
                                    :class="answers[activeLessonTab][q.sinav_soru_id] == answerName ? 'fe-stop-circle' : 'fe-circle'" 
                                    class="fe">
                                    </i> 
                                    {{ sendingAnswer == true && sendingAnswerName == answerName && sendingAnswerIndex == activeLessonTab ? 'Cevap gönderiliyor...' : answerName }}
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav'
import ScoreBoard from '@/components/ScoreBoard'
import Head from '@/components/Head'
import base from '@/mixins/base'
import http from '@/helpers/http'
import { Base64 } from 'js-base64'; // Base64 package import
import _ from 'lodash-es'
export default {
  name: 'HomeWorkDetail',
  components: { TopNav, Head, ScoreBoard },
  mixins: [ base ],
  data () {
    return {
      studentID: this.$store.state.auth.student_id, // Student ID
      examID: parseInt(this.$route.params.id), // Exam ID
      loading: true,
      examDetail: null,  // Exam Datas
      answers: {}, // Student answer
      answersKeys: {}, // Answer Keys
      message: 'Yükleniyor...', // Alert message
      questions: {}, // Question Datas
      drawArea: {}, // Drawing Area Init Datas
      startButton: false, // Start Button Visibility
      headStatus: false, // It's working for Head Component
      startButtonText: 'Sınavı Başlat', // Start Button Name
      minute: '00', // Remaining Minutes
      second: '00', // Remaining Seconds
      active: 0, // Active Tab Number
      quizResult: { // Quiz Computed Result
        true: 0,
        false: 0,
        empty: 0,
        score: 0
      },
      ready: false, // Data Status Variable
      sendingAnswer: false, // Answer Sending Status
      sendingAnswerName: '', // Sending Answer Name (we are using for interesting button name changes)
      sendingAnswerIndex: 0, // Sending Answer Index (we are using for interesting button)
      activeModal: 0, // Active modal for active class control
      temporary_q: null, // Temporary question data for dynamic html gerenate
      drawColor: '#ff0000', // Draw pen color
      activeLessonTab: null, // Active lesson tab
      activeLessonTabChanged: false, // active lesson first change detect
      previousPageRoute: 'HomeWork', // Previous page route, for old or active exam list page
      optionPack: ['A', 'B', 'C', 'D', 'E'], // Question answer option
      activeQuestionId: 0, // Active question ID
      drawKey: 0,
      drawLessonIndex: 0, // active tab index to draw matrix
      fetchActive: false, // exam detail fetch action status  
      regeneratedQuestions: {},
      examIsActive: false, // active exam control
      examIsAvailable: false, // available exam control
      resultPermission: false, // result permission
      emergencyAlert: '', // Emergency Alert
      mode: 'normal',
    }
  },
  computed: {
    videoHtml: function() {
      return `<div class="video-fancy"><h2>` + this.temporary_q.ders_adi + ` - ` + this.temporary_q.konu + `/` + this.temporary_q.alt_konu + `</h2><div id="player` + this.temporary_q.soru_id + `" ref="video_box ` + this.temporary_q.soru_id + `" class="embed-responsive-item" data-plyr-provider="vimeo" data-plyr-embed-id="` + this.temporary_q.vimeo_id + `"></div></div>`
    },
    
  },
  methods: {
    orderedQuestions() {
      let data = this.questions
      let generatedData = {}
      Object.entries(data).forEach(([key, value]) => {
        value[0].key = parseInt(key)
        generatedData[key] = value
      })
      data = _.sortBy(generatedData, [function(o) {
        return o[0].sira; 
      }])
      this.regeneratedQuestions = data
    },
    test(q) {
      console.log(q)
    },
    activeLessonTabReturner(index) {
      if (this.activeLessonTab == index) return true
      else return false
    },
    /* Active Tab and Answer Control */
    answerClass(answer_name, index, question_id) { // eslint-disable-line
      let ret = ''

      let user_answer = null// this.answers[index] !== undefined && this.answers[index][question_id] !== undefined && this.answers[index][question_id] !== null ? this.answers[index][question_id] : null;
      let true_answer = null// this.answersKeys[index] !== undefined && this.answersKeys[index][question_id] !== undefined && this.answersKeys[index][question_id] !== null ? this.answersKeys[index][question_id] : null;
      if (!this.examIsActive && this.resultPermission) { // finished
        if (user_answer == answer_name && user_answer != null && user_answer == true_answer) {
        // if ((user_answer == answer_name && user_answer == true_answer || user_answer != answer_name && user_answer != null) && answer_name == true_answer)
          ret = 'btn-success'
        } else if (user_answer == answer_name && user_answer != null && user_answer != true_answer) {
          ret = 'btn-danger'
        }
      } else { // progressing
        if (user_answer != null && user_answer == answer_name) {
          ret = 'btn-primary' // checked answer
        }
      }

      if (ret == '') {
        ret = 'btn-white'
      }
      
      if (this.answers[index][question_id] == answer_name) {
        ret = 'btn-primary'
      }
      return ret
    },
    totalMinute() {
      let e = this.examDetail
      let ret = (e.sure * 60);
      if ((this.time(e.sinav_bitis) - this.time(e.sinav_baslama)) < ret) {
        ret = (this.time(e.sinav_bitis) - this.time(e.sinav_baslama))
      }
      ret = (ret / 60).toString()
      this.minute = ret
      return ret   
    },
    videoToggle(q) { // eslint-disable-line
    this.temporary_q = q
      $.fancybox.open(this.videoHtml); // eslint-disable-line
      setTimeout(() => {
        let Plyr = this.$plyr
       // $(this.$refs['video_box' + this.video_id]).modal('show') 
        let player = new Plyr($('#player' + q.soru_id)[0], { // eslint-disable-line
            i18n: {
              play: 'Oynat',
              pause: 'Durdur',
              volume: 'Ses',
              mute: 'Sesi Kapat',
              unmute: 'Sesi Aç',
              enableCaptions: 'Açıklamaları etkinleştir',
              disableCaptions: 'Açıklamaları pasifleştir',
              download: 'İndir',
              enterFullscreen: 'Tam ekrana geçiş yap',
              exitFullscreen: 'Tam ekrandan çık',
              frameTitle: '{title} için oynatıcı',
              captions: 'Açıklamalar',
              settings: 'Ayarlar',
              menuBack: 'Önceki menüye dön',
              speed: 'Hız',
              normal: 'Normal',
              quality: 'Kalite',
              loop: 'Döngü',
              start: 'Oynat',
              end: 'Son',
              all: 'Tümü',
              reset: 'Sıfırla',
              disabled: 'Pasif',
              enabled: 'Aktif',
          },
          settings: []
        })
      }, 150)
    },
    tabStatusClass(index, q_id) {
      let ret = '';
      q_id = parseInt(q_id)
      if (typeof this.answers[index][q_id] !== 'undefined' && typeof this.answersKeys[index][q_id] !== 'undefined' && (!this.examIsActive && !this.examIsAvailable) && this.resultPermission) {
        if (this.answers[index][q_id] !== undefined && this.answersKeys[index][q_id] == this.answers[index][q_id]) {
          ret = ' true-answer' // this.message!='' && 
        } else if (this.answers[index][q_id] !== undefined && this.answers[index][q_id] !== '' && this.answers[index][q_id] !== null && this.answersKeys[index][q_id] != this.answers[index][q_id]) {
          ret = ' false-answer'
        }
      }
      return ret
    },
    activeTabCheck(index, q_id) { // eslint-disable-line
      q_id = parseInt(q_id)
      let ret = false;
      if (localStorage.getItem('QuestionAnswers' + this.examID) !== null) {
        let data = JSON.parse(localStorage.getItem('QuestionAnswers' + this.examID))
        if (data[index] !== undefined && data[index] != null && data[index][q_id] !== undefined && data[index][q_id] != null) {
          ret = true
        }
      }
      return ret
    },
    answerControl(answer, index) {
      let ret = false 
      if (localStorage.getItem('QuestionAnswers' + this.examID) !== null) {
        let data = localStorage.getItem('QuestionAnswers' + this.examID)
        if (data[index] !== undefined) {
          if (data[index] == answer) {
            ret = true
          }
        }
      }
      return ret
    },
    cleanDrawArea(index) {
      if (this.drawArea[index] !== undefined) {
        this.drawArea[index].clear()
      }
    },
    /* API Actions */
    startExam() {
      let count = 5;
      let z = setInterval( () => {
        if (count <= 0) {
          http.post('sinav-basla', {
            ogrenciID: this.studentID,
            sinavID: this.examID
          }).then(response => {
            if (response.data != undefined && response.data && response.data.baslama_tarihi !== undefined) {
              localStorage.setItem('QuestionStartTime' + this.examID, Base64.encode(this.time(response.data.baslama_tarihi)))
              this.examIsActive = true
            } else if (response.data != undefined && response.data.error) {
              this.startButtonText = 'Sınav oturumunuz başlatılamadı!'
            }
            clearInterval(z)
          }).catch(error => { // eslint-disable-line
            this.startButtonText = 'Başlama tarihi kaydedilirken bir sorun oluştu'
            clearInterval(z)
            throw error
          });
        } else {
          this.startButtonText = '...' + count + '...'
        }
        count = count - 1;
      }, 1000);
    },
    
    answerSend(answer, index, q_id, empty_answer = false) {
  
      if (!this.sendingAnswer) {
        if (this.examIsActive) {
          if (empty_answer) {
            answer = null
          }

          this.sendingAnswer = true
          this.sendingAnswerName = answer
          this.sendingAnswerIndex = q_id

          http.post('sinav-cevap-kaydet', {
            ogrenciID: this.studentID,
            sinavSoruID: q_id,
            bolumID: index,
            sinavID: this.examDetail.id,
            cevap: (answer == null ? '' : answer)
          }).then(response => {
            if (response.data != undefined && (response.data == true || response.data == 'true')) {
              let data = []
              if (localStorage.getItem('QuestionAnswers' + this.examID) !== null) {
                data = JSON.parse(localStorage.getItem('QuestionAnswers' + this.examID))
              }
              if (answer == null) answer = '';

              data[index][q_id] = answer
              this.answers[index][q_id] = answer
              localStorage.setItem('QuestionAnswers' + this.examID, JSON.stringify(data))
              this.sendingAnswerName = ''
              this.sendingAnswerIndex = 0
              this.emergencyAlert = '';

            }
            setTimeout(() => { this.sendingAnswer = false }, 1200); 
          }).catch(error => {
            setTimeout(() => { this.sendingAnswer = false }, 1200); 
            

            if (error.response.data.message !== undefined) {
              this.emergencyAlert = error.response.data.message
            }
            throw error;
          });
        } else {
          alert("Aktif olmayan sınavlarda soru işaretleme yapılamaz!");
        }
      }
      
    },
    
    /* Data Sync and Init Base Libs */
    dataSyncheiser() {
      let localRecords = null // eslint-disable-line
      if (localStorage.getItem('QuestionAnswers' + this.examID) !== null) {
        localRecords = JSON.parse(localStorage.getItem('QuestionAnswers' + this.examID))
      }
      let Atrament = this.$atrament // eslint-disable-line
      let firstLessonId = null
      let firstQuestionId = null
      Object.entries(this.regeneratedQuestions).forEach(([index, element]) => {// eslint-disable-line
        index = element[0].key
        if (firstLessonId == null) firstLessonId = index
        if(this.answersKeys[index] === undefined) this.answersKeys[index] = {};
        if(this.answers[index] === undefined) this.answers[index] = {};
        Array.from(element[0].soru_bilgileri).forEach((detail, index2) => { // eslint-disable-line
          let key = parseInt(detail.sinav_soru_id)
          if (firstQuestionId == null) firstQuestionId = key
          this.answersKeys[index][key] = this.answerHash(detail.soru_cevap);
          if(detail.ogrenci_cevap != null && detail.ogrenci_cevap != ''){
            this.answers[index][key] = detail.ogrenci_cevap;
          } else {
            this.answers[index][key] = null;
          }
          /*
          if (localRecords != null && localRecords[index][key] != undefined && localRecords[index][key] != '') {
            this.answers[index][key] = localRecords[index][key]
          }
          */
        })
      })
      
      this.ready = true
      this.activeQuestionId = firstQuestionId
      this.activeLessonTab = firstLessonId
      /*
      setTimeout(() => { // for preparing first question's draw area
          let w = this.$refs['img' + firstQuestionId][0].scrollWidth
          let h = this.$refs['img' + firstQuestionId][0].scrollHeight
          this.drawArea[firstQuestionId] = new Atrament(this.$refs['canvas' + firstQuestionId][0], {
            width: w,
            height: h,
            smoothing: 0.4,
            adaptiveStroke: false,
            color: this.drawColor
          });
      }, 1000);
      */
      localStorage.setItem('QuestionAnswers' + this.examID, JSON.stringify(this.answers))
    },
    getStartTime() { // eslint-disable-line

      this.message = ''
      if (this.time(this.examDetail.sinav_bitis) < this.time()) { // past exam
        this.headStatus = false
        this.drawColor = '#0000ff'
        if (this.examDetail.baslama_tarihi !== null) {
          localStorage.removeItem('QuestionStartTime' + this.examID)
        } else {
          localStorage.setItem('QuestionStartTime' + this.examID, Base64.encode(this.time(this.examDetail.sinav_baslama)))
        }
      } else if (this.examDetail.baslama_tarihi !== null) { // started exam
        this.headStatus = false
        this.examIsActive = true
        this.examIsAvailable = true

        localStorage.setItem('QuestionStartTime' + this.examID, Base64.encode(this.time(this.examDetail.baslama_tarihi)))
      } else { // not started exam
        this.headStatus = true
        this.examIsActive = false
        this.examIsAvailable = true
        this.totalMinute();
      }
      this.loading = false
    },
    /* External Methods */
    scoreCalc() {
      this.quizResult.empty = 0
      this.quizResult.true = 0
      this.quizResult.false = 0
      Object.entries(this.regeneratedQuestions).forEach(([index, element]) => { // eslint-disable-line
        let i = parseInt(element[0].key)
        Array.from(element[0].soru_bilgileri).forEach((detail, index2) => { // eslint-disable-line
          let i2 = parseInt(detail.sinav_soru_id)
          if (this.answers[i][i2] == null) this.quizResult.empty = this.quizResult.empty + 1
          else if (this.answers[i][i2] == this.answersKeys[i][i2]) this.quizResult.true = this.quizResult.true + 1
          else this.quizResult.false = this.quizResult.false + 1
        })
      })
      let balance = 100 / (parseInt(this.quizResult.true) + parseInt(this.quizResult.false) + parseInt(this.quizResult.empty));
      if (this.quizResult.true) {
        this.quizResult.score = Math.round(this.quizResult.true * balance);
      }
    },
    fetchExamDetail(oldExam = false) {
      if (! this.fetchActive) {
        this.fetchActive = true
        return http.post('sinav-detay', {
          ogrenciID: this.studentID,
          sinavID: this.examID
        }).then(response => {
          if (response.data != undefined && response.data) {
            if (response.data.secenek_sayisi < 5) { // exam option
              this.optionPack = ['A', 'B', 'C', 'D']
            }
            if (oldExam) { // this is to change the back button route
              this.previousPageRoute = 'OldHomeWork'
            }
            this.examDetail = response.data

            this.questions = response.data.sorular
            this.orderedQuestions()
            this.dataSyncheiser()
            this.getStartTime()
            this.loading = false
            this.fetchActive = false
            return true
          } else {
            return false
          }
        }).catch(error => { // eslint-disable-line
        console.log(error)
          // throw error
          return null
        });
      } else {
        return false
      }
    }
  },
  created() {
    document.onkeydown = function () {
      if (window.event.keyCode > 36 && window.event.keyCode < 41) // right and left button disable
        return false;
    }
    this.deviceTimeNConnectionCheck() // device time and connection controller

    // vuex data control
    if (this.$store.state.exam.home_work === null) { // fetch active exams
      this.homeWorkData(this.studentID);
    }
    if (this.$store.state.exam.old_home_work === null) { // fetch passive exams
      this.homeWorkData(this.studentID, 'pasif');
    }

    let detectExam = false
    let weTried = 0
    let realTime =  setInterval( () => {
      if (this.examDetail !== null) { // examDetail is ready
        if (this.examIsActive) {
          this.scoreCalc();
          let start_time = localStorage.getItem('QuestionStartTime' + this.examID)
          start_time = Base64.decode(start_time)
          let time = this.timeCheck(this.examDetail.sinav_baslama, this.examDetail.sinav_bitis, (this.examDetail.sure * 60), start_time) // eslint-disable-line
          time = this.secondToTime(time)

          if ((time.m <= 0 && Number(time.s) <= 0) || this.time() > this.time(this.examDetail.sinav_bitis)) {
            this.drawColor = '#0000ff'
            let xyz = setInterval(() => {
              if (Object.keys(this.drawArea).length > 0) {
                Object.entries(this.drawArea).forEach(draw => {
                  draw[1].color = '#0000ff';
                });
                clearInterval(xyz);
              }
            }, 1);
            this.headStatus = false
            this.examIsAvailable = false
            this.examIsActive = false
            this.minute = '00'
            this.second = '00'
            clearInterval(realTime)
          } else {
            this.headStatus = null;
            this.minute = time.m < 0  ? Math.abs(0).toString().padStart(2, '0') : Math.abs(time.m).toString().padStart(2, '0')
            this.second = Math.abs(time.s).toString().padStart(2, '0')
          }
        }
      } else if (! this.fetchActive && weTried < 10) { // exam detail is not ready and no pulling data running

        let questionsData = null
        // active exam control
        if (this.$store.state.exam.home_work !== null) {
          questionsData = this.$store.state.exam.home_work;
          if (Object.keys(questionsData).length) {
            questionsData.forEach(question => {
              if (question.id == this.examID) {
                detectExam = true
                this.fetchExamDetail()
              }
            })
          }
          weTried = weTried + 1
        }
        // passive exam control
        if (!detectExam && this.$store.state.exam.old_home_work !== null) {
          weTried = weTried + 1;
          questionsData = this.$store.state.exam.old_home_work;
          if (Object.keys(questionsData).length) {
            questionsData.forEach(question => {
              if (question.id == this.examID) {
                detectExam = true
                this.fetchExamDetail(true)
              }
            })
          }
          weTried = weTried + 1
        }
        
      } else if (weTried > 10) { // exam detail is not found
        this.message = 'Böyle bir sınav kaydı bulamadık.'
        clearInterval(realTime);
      }
    }, 1000);
  },
  watch: {
    activeLessonTab: function name(key) {
      key = parseInt(key)
      // let detected = false;
      Object.entries(this.regeneratedQuestions).forEach(([index, element]) => {// eslint-disable-line
        if (element[0].key == key) {
          this.drawKey = parseInt(index)
          Array.from(element[0].soru_bilgileri).forEach((detail, index2) => { // eslint-disable-line
            let q_id = parseInt(detail.sinav_soru_id)
            this.activeQuestionId = q_id
            this.active = 0
            setTimeout(() => {
              this.active = 1
            }, 1);
            /*
            if (!detected){
              this.active = 1
            } 
            */
          })
        }
      })
    },
    active: function name(key) {
      key = (parseInt(key) - 1)
      let detected = false
      let recover = false
      Object.entries(this.regeneratedQuestions).forEach(([index, element]) => {// eslint-disable-line
        if (element[0].key == this.activeLessonTab) {
          Array.from(element[0].soru_bilgileri).forEach((detail, index2) => { // eslint-disable-line
            let id = parseInt(detail.sinav_soru_id)
            if (!detected && key == index2) {
              detected = true
              this.activeQuestionId = id
            }
            if (key == index2) {
              recover = id
            }
            // console.log(key, index2, id, recover)
          })
        }
      })

      if (!detected && recover != false) {
        //console.log(recover)
        this.activeQuestionId = recover
      }
    },
    activeQuestionId: function name(key) {
      key = parseInt(key)
      if (this.drawArea[key] ===  undefined) {
        let Atrament = this.$atrament; // eslint-disable-line
        setTimeout(() => {
          if (this.activeQuestionId == key && this.activeQuestionId !== 0) {
            let w = this.$refs['img' + key][this.drawKey].scrollWidth
            let h = this.$refs['img' + key][this.drawKey].scrollHeight
            this.drawArea[key] = new Atrament(this.$refs['canvas' + key][this.drawLessonIndex], {
              width: w,
              height: h,
              smoothing: 0.4,
              adaptiveStroke: false,
              color: this.drawColor
            });
          }
        }, 50);
      }
    }
  }
}
</script>
<style scoped>
.badge-answer {
  padding: 6px;
  display: inline-block;
  border-radius: 6px;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.row {
  transition: 0.2s ease-out;
}
.blurred {
  filter: blur(9px) grayscale(1);
  pointer-events: none;
}
.btn-group-toggle.special {
  display: flex;
  flex: 1;
}

.question_img {
  padding: 1em 2em;
  max-width: 800px;
  display: block;
  margin: 0 auto;
}
li.clicked a {
    color: #505050;
    background-color: #e8e8e8;
}

.nav-link {
    margin-right: 5px
}
.btn-lg {
  font-size: 25px;
}

.spec-nav {
  flex-wrap: nowrap;
}
.spec-header {
  overflow-x: scroll;
  overflow-y: hidden;
}

@media (max-width: 1199px) {
  .question_img {
    min-width: 35vh
  }
}

.list-group .list-group-item:last-child {
  border: 0;
}

.btn-left {
  top: 48%;
  left: -25px;
  position: absolute;
}

.btn-right {
  top: 48%;
  right: -25px;
  position: absolute;
}

li.false-answer a {
  background: #e63757 !important;
  color: #ffffff !important;
}

li.true-answer a {
  background: #00d97e !important;
  color: #ffffff !important;
}
li.true-answer a.active,
li.false-answer a.active {
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.38);
}

a.canvas_area {
  position: relative;
}
canvas {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.question-number {
  z-index: 5;
}
</style>